import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-sms",
  "use": "icon-sms-usage",
  "viewBox": "0 0 58.98 44",
  "content": "<symbol viewBox=\"0 0 58.98 44\" id=\"icon-sms\">\r\n    <path d=\"M44,0H15A15,15,0,0,0,0,15v3.85a15,15,0,0,0,15,15H37L45.36,44V33.78A15,15,0,0,0,59,18.85V15A15,15,0,0,0,44,0ZM18.08,20.34A3.38,3.38,0,1,1,21.48,17,3.38,3.38,0,0,1,18.08,20.34Zm11.38,0A3.38,3.38,0,1,1,32.86,17,3.38,3.38,0,0,1,29.46,20.34Zm11.35,0A3.38,3.38,0,1,1,44.21,17,3.38,3.38,0,0,1,40.81,20.34Z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./app/general/svg/sms.svg
// module id = DPol
// module chunks = 0